import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bafea30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "VoiceListTableContainer" }
const _hoisted_2 = { class: "voiceRecordTitle" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "录音", -1))
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "example-pagination-block" }
const _hoisted_6 = { style: {"float":"left","width":"20%"} }
const _hoisted_7 = { class: "dialog-footer" }

import { useRoute } from 'vue-router';
import { onMounted, computed, ref } from 'vue';
import { voiceRecordAPI } from '@/api/voiceRecord';
import { VoiceRecord, VoiceRecordDownloadStatus, VoiceRecordState, VoiceRecordStatusFilter } from '@/store/modules/voiceRecord/types';
import { ElMessage } from 'element-plus'
import changeToDateTime from '@/utils/timestamp2DateTime';
import { AVWaveform, AVLine } from 'vue-audio-visual';
import WaveSurfer from 'wavesurfer.js'
// import WaveSurfer from 'wavesurfer.js/dist/wavesurfer'


import { defineComponent } from 'vue';

const __default__ = defineComponent({
    name: "RecordWindow",
});

interface TimeLineNode {
    content: number,
    timeToDisplay: string,
    timestamp: string,
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute();
const projectId = computed(() => typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0])
const targetId = computed(() => typeof (route.params.targetId) === "string" ? route.params.targetId : route.params.targetId[0]);
const voiceRecordState = ref<VoiceRecordState>({
    VoiceRecordList: [],
    isLoading: false,
})
const popoverVisible = ref<boolean>(false)

const dialogVisible = ref<boolean>(false)
const dialogNode = ref<VoiceRecord>()
const pageSize = ref<number>(10)
const currentPage = ref<number>(1)
const totalLength = ref<number>(0)

const timeLineSlice = ref<TimeLineNode[]>([])
const nowTimeNode = ref<string>("")

const selectedVoiceRecord = ref<VoiceRecord>()
const isWaveShow = ref<boolean>(false)
const wavesurfer = ref<WaveSurfer[]>([])
const waveLoading = ref<boolean>(false)

const handleRowClick = (row: VoiceRecord) => {
    selectedVoiceRecord.value = row
}

const refreshVoiceRecordList = async () => {
    if (voiceRecordState.value.isLoading === false) {
        const projId = projectId.value
        const uid = targetId.value

        try {
            wavesurfer.value?.forEach(data => {
                data.destroy()
            })
            voiceRecordState.value.isLoading = true
            timeLineSlice.value = []
            const times = await voiceRecordAPI.getVoiceRecordTimeLineByProjIdAndUid(projId, uid)
            if (times.length !== 0) {
                const res = await voiceRecordAPI.listVoiceRecordByTime(projectId.value, uid, times[0].timeStamp);
                voiceRecordState.value.VoiceRecordList = res
                totalLength.value = res.length;
                times.forEach(item => {
                    timeLineSlice.value.push({
                        content: item.id,
                        timeToDisplay: changeToDateTime(parseInt(item.timeStamp)),
                        timestamp: item.timeStamp
                    })
                })
                nowTimeNode.value = times[0].timeStamp

            }
            isWaveShow.value = false
        } catch (err) {
            console.log(err)
        } finally {
            voiceRecordState.value.isLoading = false
        }
    }
}
const genWave = async () => {
    waveLoading.value = true
    wavesurfer.value?.forEach(data => {
        data.destroy()
    })
    wavesurfer.value = []
    isWaveShow.value = true
    if (isWaveShow.value) {
        let data = voiceRecordState.value.VoiceRecordList.slice((currentPage.value - 1) * pageSize.value, currentPage.value * pageSize.value)
        data.forEach(data => {
            let wave = WaveSurfer.create({
                container: `#waveForm${data.id}`,
                url: data.ossLink,
                cursorColor: 'white',
                autoCenter: false,
                waveColor: 'green',
                progressColor: 'green',
                height: 50,
                interact: false,
            })
            wavesurfer.value.push(wave)
            data.waveLoading = true

            wave.on("ready", () => {
                data.waveLoading = false
            })
            wave.on("error", (error: any) => {
                data.waveLoading = false
            })
        })
    }
}

const handleCurrentChange = () => {
    wavesurfer.value?.forEach(data => {
        data.destroy()
    })
    wavesurfer.value = []
}
const handleGetDownloadLink = async (row: VoiceRecord) => {

    if (voiceRecordState.value.isLoading === false) {
        voiceRecordState.value.isLoading = true

        const projId = projectId.value
        const uid = targetId.value
        try {
            await voiceRecordAPI.getVoiceRecordDownLoadLink(projId, uid, row.id)
        } catch (err) {
            console.log(err)
        } finally {
            voiceRecordState.value.isLoading = false
        }
    }
}


const handleDownloadToggle = (node: VoiceRecord) => {
    dialogVisible.value = true
    dialogNode.value = node
}

const openDownloadPage = (node: VoiceRecord | undefined): void => {
    try {
        if (node === undefined) {
            return
        }
        let urlSlice = node.url.split('#!')
        if (urlSlice.length === 1) {
            ElMessage({
                message: '无效链接',
                type: 'error',
            })
        } else {
            window.open(`https://mega.nz/file/${urlSlice[urlSlice.length - 1]}#${node.pwd}`)
        }
    } catch (err) {
        console.log(err)
    }
}

const copyLink = (node: VoiceRecord | undefined): void => {
    try {
        if (node === undefined) {
            return
        }
        let urlSlice = node.url.split('#!')
        if (urlSlice.length === 1) {
            ElMessage({
                message: '无效链接',
                type: 'error',
            })
        } else {
            copyText(`https://mega.nz/file/${urlSlice[urlSlice.length - 1]}#${node.pwd}`)
        }
    } catch (err) {
        console.log(err)
    }
}

const copyText = (data: string | undefined): void => {
    if (data === undefined) {
        return
    }
    let oInput = document.createElement('input');
    oInput.value = data;
    document.body.appendChild(oInput);
    oInput.select();
    document.execCommand("Copy");
    oInput.style.display = 'none';
    ElMessage({
        message: '复制成功',
        type: 'success',
    })
}

const filterForChange = (value: number, row: VoiceRecord) => {
    return row['download_status'] === value;
}

const getTimeLine = () => {
    for (let i = 0; i < voiceRecordState.value.VoiceRecordList.length; i++) {
        let node = {
            content: voiceRecordState.value.VoiceRecordList[i].id,
            timeToDisplay: changeToDateTime(parseInt(voiceRecordState.value.VoiceRecordList[i].timeStamp)),
            timestamp: voiceRecordState.value.VoiceRecordList[i].timeStamp
        }
        if (!timeLineSlice.value.find(time => time.timeToDisplay === node.timeToDisplay)) {
            timeLineSlice.value.push({
                content: voiceRecordState.value.VoiceRecordList[i].id,
                timeToDisplay: changeToDateTime(parseInt(voiceRecordState.value.VoiceRecordList[i].timeStamp)),
                timestamp: voiceRecordState.value.VoiceRecordList[i].timeStamp
            })
        }
    }
}

const getDisplayTime = (data: string) => {
    const date = (new Date(new Date(new Date(data).toUTCString()).getTime() + 8 * 60 * 60 * 1000)).toISOString()
    return date.substring(0, 10) + "  " + date.substring(11, 19)
}

const handleChooseTime = async (date: string, id: number) => {
    popoverVisible.value = false
    voiceRecordState.value.isLoading = true
    const uid = targetId.value
    nowTimeNode.value = date
    try {
        wavesurfer.value?.forEach(data => {
            data.destroy()
        })
        const res = await voiceRecordAPI.listVoiceRecordByTime(projectId.value, uid, date);
        voiceRecordState.value.VoiceRecordList = res
        totalLength.value = res.length;
        isWaveShow.value = false
    } catch (err) {
        voiceRecordState.value.VoiceRecordList = [];
    } finally {
        voiceRecordState.value.isLoading = false
    }

}

onMounted(async () => {
    try {
        voiceRecordState.value.isLoading = true;
        const projId = projectId.value
        const uid = targetId.value
        const times = await voiceRecordAPI.getVoiceRecordTimeLineByProjIdAndUid(projId, uid)
        if (times.length !== 0) {
            const res = await voiceRecordAPI.listVoiceRecordByTime(projectId.value, uid, times[0].timeStamp);
            nowTimeNode.value = times[0].timeStamp
            voiceRecordState.value.VoiceRecordList = res
            totalLength.value = res.length;
        }
        times.forEach(item => {
            timeLineSlice.value.push({
                content: item.id,
                timeToDisplay: changeToDateTime(parseInt(item.timeStamp)),
                timestamp: item.timeStamp
            })
        })
        // const res = await voiceRecordAPI.getVoiceRecordListByUid(projId, uid)
        // voiceRecordState.value.VoiceRecordList = res
        // getTimeLine()
        // totalLength.value = res.length;
    } catch (err) {
        console.log(err)
    } finally {
        voiceRecordState.value.isLoading = false
    }
})


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_popover, {
        placement: "bottom",
        title: " ",
        width: 400,
        trigger: "hover"
      }, {
        reference: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            style: {"float":"right","margin-right":"10px","margin-bottom":"10px"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (popoverVisible.value = true))
          }, {
            default: _withCtx(() => [
              _createTextVNode("切换时间")
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_timeline, { class: "TimeLinePopover" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timeLineSlice.value, (timeNode, index) => {
                return (_openBlock(), _createBlock(_component_el_timeline_item, {
                  key: index,
                  timestamp: timeNode.timeToDisplay,
                  onClick: ($event: any) => (handleChooseTime(timeNode.timestamp, timeNode.content)),
                  type: timeNode.timestamp === nowTimeNode.value ? 'primary' : ''
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(timeNode.timeToDisplay), 1)
                  ]),
                  _: 2
                }, 1032, ["timestamp", "onClick", "type"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "refresh",
        type: "primary",
        style: {"float":"right","margin-right":"10px","margin-bottom":"10px"},
        onClick: refreshVoiceRecordList
      }, {
        default: _withCtx(() => [
          _createTextVNode("刷新")
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "genWave",
        type: "primary",
        style: {"float":"right","margin-right":"10px","margin-bottom":"10px"},
        onClick: genWave
      }, {
        default: _withCtx(() => [
          _createTextVNode("生成波形图")
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_container, { class: "VoiceRecordListContainer" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_main, { class: "voiceRecordList" }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: voiceRecordState.value.VoiceRecordList.slice((currentPage.value - 1) * pageSize.value, currentPage.value * pageSize.value),
              style: {"width":"100%"},
              stripe: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "id",
                  label: "id"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "filename",
                  label: "文件名"
                }),
                _createVNode(_component_el_table_column, {
                  label: "下载状态",
                  filters: _unref(VoiceRecordStatusFilter),
                  "filter-method": filterForChange,
                  "filter-multiple": false
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.download_status === _unref(VoiceRecordDownloadStatus).Uploaded)
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 0,
                          type: "info"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("已上传")
                          ]),
                          _: 1
                        }))
                      : (scope.row.download_status === _unref(VoiceRecordDownloadStatus).Downloaded)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 1,
                            type: "success"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("已下载")
                            ]),
                            _: 1
                          }))
                        : (scope.row.download_status === _unref(VoiceRecordDownloadStatus).Downloading)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 2,
                              type: "info"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("下载中")
                              ]),
                              _: 1
                            }))
                          : (scope.row.download_status === _unref(VoiceRecordDownloadStatus).Failed)
                            ? (_openBlock(), _createBlock(_component_el_tag, {
                                key: 3,
                                type: "danger"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("失败")
                                ]),
                                _: 1
                              }))
                            : (scope.row.download_status === _unref(VoiceRecordDownloadStatus).Idle)
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 4,
                                  type: "info"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("未知")
                                  ]),
                                  _: 1
                                }))
                              : (scope.row.download_status === _unref(VoiceRecordDownloadStatus).Playable)
                                ? (_openBlock(), _createBlock(_component_el_tag, {
                                    key: 5,
                                    type: "success"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("可播放")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["filters"]),
                _createVNode(_component_el_table_column, { label: "操作" }, {
                  default: _withCtx((scope) => [
                    (scope.row.download_status === _unref(VoiceRecordDownloadStatus).Uploaded)
                      ? (_openBlock(), _createBlock(_component_el_link, {
                          key: 0,
                          type: "success",
                          onClick: ($event: any) => (handleGetDownloadLink(scope.row))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("生成链接")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : (scope.row.download_status === _unref(VoiceRecordDownloadStatus).Downloaded)
                        ? (_openBlock(), _createBlock(_component_el_link, {
                            key: 1,
                            type: "success",
                            onClick: ($event: any) => (handleDownloadToggle(scope.row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("下载")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : (scope.row.download_status === _unref(VoiceRecordDownloadStatus).Downloading)
                          ? (_openBlock(), _createBlock(_component_el_link, {
                              key: 2,
                              type: "primary",
                              disbaled: ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("下载中...")
                              ]),
                              _: 1
                            }))
                          : (scope.row.download_status === _unref(VoiceRecordDownloadStatus).Playable && scope.row !== selectedVoiceRecord.value)
                            ? (_openBlock(), _createBlock(_component_el_link, {
                                key: 3,
                                type: "success",
                                onClick: ($event: any) => ( handleRowClick(scope.row))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("播放")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : (scope.row.download_status === _unref(VoiceRecordDownloadStatus).Playable && scope.row === selectedVoiceRecord.value)
                              ? (_openBlock(), _createBlock(_component_el_link, {
                                  key: 4,
                                  type: "success",
                                  disbaled: "",
                                  onClick: ($event: any) => ( handleRowClick(scope.row))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("播放中...")
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "波形图" }, {
                  default: _withCtx((scope) => [
                    _withDirectives(_createElementVNode("div", {
                      id: 'waveForm' + scope.row.id
                    }, null, 8, _hoisted_4), [
                      [_directive_loading, scope.row.waveLoading]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, voiceRecordState.value.isLoading]
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_pagination, {
                "current-page": currentPage.value,
                "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((currentPage).value = $event)),
                background: "",
                layout: "prev, pager, next",
                total: totalLength.value,
                "page-count": Math.ceil(totalLength.value / pageSize.value),
                onCurrentChange: handleCurrentChange
              }, null, 8, ["current-page", "total", "page-count"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_footer, { class: "voiceRecordFooter" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, _toDisplayString('当前播放：' + (selectedVoiceRecord.value !== undefined ? selectedVoiceRecord.value.filename : '')), 1),
            (selectedVoiceRecord.value !== undefined && selectedVoiceRecord.value.download_status === 6 && selectedVoiceRecord.value.ossLink !== '')
              ? (_openBlock(), _createBlock(_unref(AVWaveform), {
                  key: selectedVoiceRecord.value.id,
                  src: selectedVoiceRecord.value.ossLink,
                  playtime: true,
                  "playtime-clickable": true,
                  "canv-width": 600,
                  "playtime-slider-color": "black",
                  "playtime-line-color": "green",
                  "noplayed-line-color": "#032509",
                  "canv-height": 60
                }, null, 8, ["src"]))
              : (_openBlock(), _createBlock(_unref(AVWaveform), {
                  key: 1,
                  src: "",
                  playtime: false,
                  "playtime-clickable": true,
                  "canv-width": 600,
                  "playtime-slider-color": "black",
                  "canv-height": 60
                }))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((dialogVisible).value = $event)),
      width: "30%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_7, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (openDownloadPage(dialogNode.value)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("前往下载页面")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (copyLink(dialogNode.value)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("一键复制")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("关闭 ")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_descriptions, {
          direction: "horizontal",
          column: 1
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, {
              label: "下载链接:",
              align: "center",
              width: "25%"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(dialogNode.value?.url) + " ", 1),
                _createVNode(_component_el_button, {
                  type: "primary",
                  link: "",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (copyText(dialogNode.value?.url)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("复制")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "密码:",
              align: "center",
              width: "25%"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(dialogNode.value?.pwd) + " ", 1),
                _createVNode(_component_el_button, {
                  type: "primary",
                  link: "",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (copyText(dialogNode.value?.pwd)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("复制")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})